import AssociationActivity from './AssociationActivity';

export default class AssociationRegistrationRequest {
    name: string;
    organisationNumber: string;
    externalId: string;

    associationActivities: Array<AssociationActivity>; 

    constructor(
        name: string,
        organisationNumber: string,
        externalId: string,
        associationActivities: Array<AssociationActivity>
    ) {
        this.name = name;
        this.organisationNumber = organisationNumber;
        this.externalId = externalId;     
        this.associationActivities = associationActivities;

    }
}